<template>
  <ds-dropdown
    v-if="shouldShowDropdown"
    title="Ações"
    right
    prevent-click-row
    size="sm"
    :button-class="buttonClass">
    <ds-dropdown-item
      v-if="shouldShowDelete"
      @click="onDelete">
      Excluir Funcionário
    </ds-dropdown-item>
    <ds-dropdown-item
      v-if="shouldShowEditContractData"
      @click="onEditContract">
      Editar Dados do Contrato
    </ds-dropdown-item>
    <ds-dropdown-item
      v-if="shouldShowEditPersonalData"
      @click="onEditPersonalData">
      Editar Dados Pessoais
    </ds-dropdown-item>
    <ds-dropdown-item
      v-else-if="shouldShowAddPersonalData"
      @click="onAddPersonalData">
      Adicionar Dados Pessoais
    </ds-dropdown-item>
    <slot></slot>
  </ds-dropdown>
</template>

<script>
import { isUserAccountant } from 'packages/common';
import { isStatusApproved, isStatusPending } from '../../../services/approvalService';
import { TABS_INDEX } from '../modals/worker-view-rollover/workerViewRolloverConstants';

export default {
  name: 'WorkerActionsPageDropdown',
  props: {
    buttonClass: String,
    useOn: {
      type: String,
      default: 'list',
      validator: type => ['list', 'rollover'].includes(type),
    },
    tabIndex: Number,
    isEditModeContract: Boolean,
    isEditModePersonal: Boolean,
    contractDataStatus: Object,
    personalData: Object,
  },
  data() {
    return {
      isRollover: this.useOn === 'rollover',
      isList: this.useOn === 'list',
    };
  },
  computed: {
    isUserAccountant() {
      return isUserAccountant();
    },
    shouldShowDropdown() {
      return this.hasOptions();
    },
    isContractTab() {
      return this.tabIndex === TABS_INDEX.CONTRACT;
    },
    isPersonalTab() {
      return this.tabIndex === TABS_INDEX.PERSONAL;
    },
    isPersonalUnregistered() {
      return !this.personalData;
    },
    isPersonalApproved() {
      return this.personalData && isStatusApproved(this.personalData.workflowTask);
    },
    isPersonalPending() {
      return this.personalData && isStatusPending(this.personalData.workflowTask);
    },
    isContractApproved() {
      return isStatusApproved(this.contractDataStatus);
    },
    isContractPending() {
      return isStatusPending(this.contractDataStatus);
    },
    shouldShowDelete() {
      return this.isUserAccountant || this.isContractPending;
    },
    shouldShowEditContractOnRollover() {
      return this.isAbleToEditContractData()
      && (!this.isEditModeContract || (this.isEditModeContract && !this.isContractTab));
    },
    shouldShowEditContractOnList() {
      return this.isAbleToEditContractData();
    },
    shouldShowEditContractData() {
      return this.isRollover
        ? this.shouldShowEditContractOnRollover
        : this.shouldShowEditContractOnList;
    },
    shouldShowEditPersonalOnList() {
      return this.isAbleToEditPersonalData();
    },
    shouldShowEditPersonalOnRollover() {
      return this.isAbleToEditPersonalData()
        && (!this.isEditModePersonal || (this.isEditModePersonal && !this.isPersonalTab));
    },
    shouldShowEditPersonalData() {
      return this.isRollover
        ? this.shouldShowEditPersonalOnRollover
        : this.shouldShowEditPersonalOnList;
    },
    shouldShowAddPersonalData() {
      return (this.isPersonalUnregistered && this.isContractTab)
      || (this.isPersonalUnregistered && this.isList);
    },
  },
  methods: {
    onDelete() {
      this.$emit('on-delete');
    },
    onEditContract() {
      this.$emit('on-edit-contract');
    },
    onAddPersonalData() {
      this.$emit('on-add-personal');
    },
    onEditPersonalData() {
      this.$emit('on-edit-personal');
    },
    isAbleToEditContractData() {
      return this.isUserAccountant || this.isContractPending;
    },
    isAbleToEditPersonalData() {
      return (this.isContractApproved || !this.isUserAccountant)
        && (this.isPersonalPending || this.isPersonalApproved);
    },
    hasOptions() {
      return this.shouldShowDelete
      || this.shouldShowEditContractData
      || this.shouldShowEditPersonalData
      || this.shouldShowAddPersonalData;
    },
  },
};
</script>

<style scoped>
div ::v-deep .ca-dropdown-menu {
  min-width: 180px;
}
</style>
